const route = {
  login: "/login",
  dashboard: "/dashboard",
  profile: "/profile",
  productupload: "/productupload",
  configuration: "/Configuration",
  vendor: "/vendorlist",
  productlist: "/productlist",
  orderlist: "/orderlist",
  orderdetails: "/orderdetails/:id",
  userorders: "/orderlist/:userid",
  userwishlist: "/userwishlist/:userid",
  address: "/address/:userid",

  materiallist: "/material",
  mastermaterial: "/materialmaster",
  mastercolors: "/mastercolors",
  masterpurities: "/masterpurities",
  salediscountlist: "/salediscountlist",
  voucherdiscountlist: "/voucherdiscountlist",

  producttypes: "/producttypes",
  voucherdiscount: "/voucherdiscount",
  salediscount: "/salediscount",
  priceupdate: "/priceupdate",
  productAttributes: "/product_attributes",
  diamondDetails: "/diamond_details",
  gemstoneDetails: "/gemstone-details",
  variants: "/variants",
  images: "/images",
  createVariant: "/create_variant",
  materiallistpage: "/newmaterial",
  editCategory: "/editcategory",
  vendorPrice: "/vendorpricesetup",
  markupPrice: "/markuppricesetup",
  taxsetup: "/taxsetup",
  editdiscount: "/salediscount/:id",
  editvoucher: "/voucherdiscount/:id",
  masterstyles: "/masterstyles",
  masterthemes: "/masterthemes",
  masteroccassions: "/masteroccassions",
  masterpaymentstatus: "/paymentstatus",
  mastercollections: "/collections",
  masterdesigns: "/designs",
  masterorderstatus: "/orderstatus",
  shippingzones: "/zones",
  shipmentsettings: "/shipmensettings",
  shippingattributes: "/shippingattributes",
  masterdiamonds: "/diamonds",
  diamondsettings: "/diamondsettings",
  diamondshapes: "/diamondshapes",
  earringbacking: "/earringbacking",
  addshippingattributes: "/addshippingattributes",
  addtaxattributes: "/addtaxattributes",
  userconfiguration: "/userconfiguration",
  masterroles: "/masterroles",
  manageadminusers: "/manageadminusers",
  goldpriceupdate: "/goldpriceupdate",

  manageusers: "/manageusers",

  masterpages: "/masterpages",

  gemsettings: "/gemstonesettings",
  gemshapes: "/gemstoneshapes",
  gemtypes: "/gemstonetypes",
  gender: "/genders",
  seo: "/seopriority",
  taxsettings: "/taxsettings",
  masterattributes: "/masterattributes",
  dynamicFilter: "/filters",

  masterstones: "/masterstones",
  masterstonecolors: "/masterstonecolors",
  masterstoneshapes: "/masterstoneshapes",
  weights: "/weights",
  customerdetails: "/customerdetails/:id",

  category: "/categories",
  countriesFx: "/countriesFx",
  imageUpload: "/imageUpload",
  banners: "/banners",
  styloribanner: "/styloribanner",
  silverbanner: "/silverbanner",
  silverlistingbanner: "/listingPage",
  warehouse: "/warehouse",
  holiday_manager: "/holiday-manager",
  inventory: "/inventory",
  abandoned_cart: "/cart-details",
  price_upload: "/price-upload",
  error_logs: "/error-logs",
  pricelogs: "/price-logs",
  GemstoneMarkupSettings: "gemstone-setting",
  CmsHome: "/cmsHome",
  NavMenu: "/navmenu",
  BannerCMS: "/bannerCMS",
  CmsComponent: "/cmsComponent",
  SearchSettings: "/search_settings",
  ComboOfferConfig:"/combo_offer_config",
  cvd: "/cvd",
  cvdDetail: "/cvd-detail",
  cvdAdd: "/cvd-add"
};

export default route;
